import React, { useState } from "react";
import { Alert, Container, Box, Typography, TextField, Button, InputAdornment, IconButton, FormControl, InputLabel, Select, MenuItem, FormHelperText } from "@mui/material";
import PlumSvg from "../component/PlumSvg";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { userAPI } from "../../Api";

const AddUser = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [tg_id, setTgId] = useState("")
  const [showPassword, setShowPassword] = useState(false);
  const [alert, setAlert] = useState(null);
  const [role, setRole] = useState("");
  
  const [errors, setErrors] = useState({
    name: "",
    tg_id:"",
    email: "",
    password: "",
    role: "",
  });

  const AlertSuccess = () => {
    return (
      <Alert severity="success">
        Пользователь создан!
      </Alert>
    );
  };

  const AlertError = () => {
    return (
      <Alert severity="error">
        Ошибка создания пользователя
      </Alert>
    );
  };

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleGeneratePassword = () => setPassword(generatePassword());

  const validateForm = () => {
    const newErrors = {};

    if (!name) newErrors.name = "Имя обязательно";
    if (!email) newErrors.email = "Email обязателен";
    else if (!/\S+@\S+\.\S+/.test(email)) newErrors.email = "Некорректный формат email";
    if (!password) newErrors.password = "Пароль обязателен";
    if (!role) newErrors.role = "Роль не выбрана";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      console.log({ name, email, password, role });
      let data = await userAPI.createUser({ name, email, password, role, tg_id });
      if (data.data.success) {
        setName("");
        setEmail("");
        setPassword("");
        setRole("");
        setAlert(<AlertSuccess />); // Устанавливаем успешное сообщение
      } else {
        setAlert(<AlertError />); // Устанавливаем ошибку
      }
    }
  };

  return (
    <Container maxWidth="sx">
      <Box sx={{ mt: 8, p: 4, boxShadow: 3, borderRadius: 2, bgcolor: "#fefcfb" }}>
        <Typography variant="h5" align="center" gutterBottom>
          <PlumSvg /> Добавить пользователя
        </Typography>
        
        {alert && <div>{alert}</div>} {/* Условный рендеринг Alert */}

        <form onSubmit={handleSubmit}>
          <TextField
            label="Имя"
            variant="outlined"
            fullWidth
            margin="normal"
            value={name}
            onChange={(e) => setName(e.target.value)}
            InputLabelProps={{ shrink: true }}
            error={Boolean(errors.name)}
            helperText={errors.name}
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": { borderColor: "#683d62" },
              },
              "& .MuiInputBase-input": { "&:focus": { color: "#683d62" } },
              "& .MuiInputLabel-root": { "&.Mui-focused": { color: "#683d62" } },
            }}
          />

          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            InputLabelProps={{ shrink: true }}
            error={Boolean(errors.email)}
            helperText={errors.email}
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": { borderColor: "#683d62" },
              },
              "& .MuiInputBase-input": { "&:focus": { color: "#683d62" } },
              "& .MuiInputLabel-root": { "&.Mui-focused": { color: "#683d62" } },
            }}
          />
            
          <TextField
            label="TgID"
            variant="outlined"
            fullWidth
            margin="normal"
            value={tg_id}
            onChange={(e) => setTgId(e.target.value)}
            InputLabelProps={{ shrink: true }}
            error={Boolean(errors.tg_id)}
            helperText={errors.tg_id}
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": { borderColor: "#683d62" },
              },
              "& .MuiInputBase-input": { "&:focus": { color: "#683d62" } },
              "& .MuiInputLabel-root": { "&.Mui-focused": { color: "#683d62" } },
            }}
          />
          <TextField
            label="Пароль"
            variant="outlined"
            fullWidth
            type={showPassword ? "text" : "password"}
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputLabelProps={{ shrink: true }}
            error={Boolean(errors.password)}
            helperText={errors.password}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleClickShowPassword}>
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": { borderColor: "#683d62" },
              },
              "& .MuiInputBase-input": { "&:focus": { color: "#683d62" } },
              "& .MuiInputLabel-root": { "&.Mui-focused": { color: "#683d62" } },
            }}
          />
          
          <Button
            variant="outlined"
            color="primary"
            onClick={handleGeneratePassword}
            sx={{ mt: 1, backgroundColor: "#683d62", color: "#fff" }}
          >
            Сгенерировать пароль
          </Button>

          <FormControl fullWidth sx={{ mt: 2 }} error={Boolean(errors.role)}>
            <InputLabel>Роль</InputLabel>
            <Select
              value={role}
              onChange={(e) => setRole(e.target.value)}
              label="Роль"
            >
              <MenuItem value="admin">Администратор</MenuItem>
              <MenuItem value="operator">Оператор</MenuItem>
            </Select>
            {errors.role && <FormHelperText>{errors.role}</FormHelperText>}
          </FormControl>

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2, backgroundColor: "#683d62" }}
          >
            Добавить пользователя
          </Button>
        </form>
      </Box>
    </Container>
  );
};

// Функция для генерации случайного пароля
function generatePassword() {
  const length = 12;
  const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()';
  let password = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charset.length);
    password += charset[randomIndex];
  }
  return password;
}

export default AddUser;
